"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SankeyConfigurationMenu = exports.OpenSankeyConfigurationsMenus = void 0;
const Accordion_1 = __importDefault(require("react-bootstrap/Accordion"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_1 = __importDefault(require("react"));
const SankeyMenuConfigurationNodes_1 = __importDefault(require("./SankeyMenuConfigurationNodes"));
// import SankeyLabelEdition from './SankeyMenuConfigurationLabel'
const SankeyMenuConfigurationLinks_1 = __importDefault(require("./SankeyMenuConfigurationLinks"));
const OpenSankeyConfigurationsMenus = (t, data, set_data, nav_item_active, set_nav_item_active, nodes_accordion_ref, links_accordion_ref, selected_node, multi_selected_nodes, multi_selected_links, selected_link, style_to_apply, set_style_to_apply, set_show_nav, menu_configuration_layout, menu_configuration_node_tags, menu_configuration_link_tags, menu_configuration_data_tags, menu_configuration_nodes, menu_configuration_links, menu_configuration_free_labels, menu_configuration_legends, sub_nav_item_active, set_sub_nav_item_active, style_editable, token, set_displayed_value, tags_selected, set_tags_selected) => {
    return [
        react_1.default.createElement(Accordion_1.default.Item, { key: '1', id: 'MEP', style: { 'display': (data.accordeonToShow.includes('MEP')) ? 'block' : 'none' }, eventKey: "1", onClick: evt => {
                if (evt.target.className === 'accordion-button' && nav_item_active === '1') {
                    set_nav_item_active('');
                }
                else {
                    set_nav_item_active('1');
                }
            } },
            react_1.default.createElement(Accordion_1.default.Header, null, t('Menu.MEP')),
            react_1.default.createElement(Accordion_1.default.Body, null, menu_configuration_layout.map((c, i) => {
                return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
            }))),
        react_1.default.createElement(Accordion_1.default.Item, { key: '2', style: { 'display': 'block' }, eventKey: "2", id: "Nodes", onClick: evt => {
                if (evt.target.className === 'accordion-button' && evt.target.textContent === t('Menu.Noeuds') && nav_item_active === '2') {
                    set_nav_item_active('');
                }
                else {
                    set_nav_item_active('2');
                }
            } },
            react_1.default.createElement(Accordion_1.default.Header, null, t('Menu.Noeuds')),
            react_1.default.createElement(Accordion_1.default.Body, { style: { padding: '0px' } },
                react_1.default.createElement(Accordion_1.default, { ref: nodes_accordion_ref, activeKey: sub_nav_item_active },
                    react_1.default.createElement(Accordion_1.default.Item, { key: '3', style: { 'display': (data.accordeonToShow.includes('EN')) ? 'block' : 'none' }, eventKey: "EtiquetteNoeud", onClick: evt => {
                            if (evt.target.className === 'accordion-button') {
                                set_sub_nav_item_active('');
                                set_nav_item_active('2');
                                set_show_nav(true);
                            }
                            else {
                                set_sub_nav_item_active('EtiquetteNoeud');
                                set_nav_item_active('2');
                                set_show_nav(true);
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, t('Menu.EN')),
                        react_1.default.createElement(Accordion_1.default.Body, null, menu_configuration_node_tags)),
                    react_1.default.createElement(Accordion_1.default.Item, { key: '4', eventKey: 'editionNoeud', onClick: evt => {
                            if (evt.target.className === 'accordion-button') {
                                set_sub_nav_item_active('');
                                set_nav_item_active('2');
                                set_show_nav(true);
                            }
                            else {
                                set_sub_nav_item_active('editionNoeud');
                                set_nav_item_active('2');
                                set_show_nav(true);
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, t('Menu.EdN')),
                        react_1.default.createElement(Accordion_1.default.Body, null,
                            react_1.default.createElement(SankeyMenuConfigurationNodes_1.default, { t: t, data: data, set_data: set_data, style_to_apply: style_to_apply, set_style_to_apply: set_style_to_apply, selected_node: selected_node, multi_selected_nodes: multi_selected_nodes, multi_selected_links: multi_selected_links, menu_configuration_nodes: Object.values(menu_configuration_nodes), style_editable: style_editable, token: token })))))),
        react_1.default.createElement(Accordion_1.default.Item, { key: '5', style: { 'display': 'block' }, id: 'Flux', eventKey: "3", onClick: evt => {
                if (evt.target.className === 'accordion-button' && nav_item_active === '3') {
                    set_nav_item_active('');
                }
                else {
                    set_nav_item_active('3');
                }
            } },
            react_1.default.createElement(Accordion_1.default.Header, null, t('Menu.flux')),
            react_1.default.createElement(Accordion_1.default.Body, { style: { padding: '0px' } },
                react_1.default.createElement(Accordion_1.default, { ref: links_accordion_ref, activeKey: sub_nav_item_active },
                    react_1.default.createElement(Accordion_1.default.Item, { key: '6', eventKey: "8", style: { 'display': (data.accordeonToShow.includes('EF')) ? 'block' : 'none' }, onClick: evt => {
                            if (evt.target.className === 'accordion-button') {
                                set_sub_nav_item_active('');
                                set_nav_item_active('3');
                                set_show_nav(true);
                            }
                            else {
                                set_sub_nav_item_active('8');
                                set_nav_item_active('3');
                                set_show_nav(true);
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, t('Menu.EF')),
                        react_1.default.createElement(Accordion_1.default.Body, null, menu_configuration_link_tags)),
                    react_1.default.createElement(Accordion_1.default.Item, { key: '7', eventKey: 'editionFlux', onClick: evt => {
                            if (evt.target.className === 'accordion-button') {
                                set_sub_nav_item_active('');
                                set_nav_item_active('3');
                                set_show_nav(true);
                            }
                            else {
                                set_sub_nav_item_active('editionFlux');
                                set_nav_item_active('3');
                                set_show_nav(true);
                            }
                        } },
                        react_1.default.createElement(Accordion_1.default.Header, { className: 'level2' }, t('Menu.EdF')),
                        react_1.default.createElement(Accordion_1.default.Body, null,
                            react_1.default.createElement(SankeyMenuConfigurationLinks_1.default, { t: t, data: data, set_data: set_data, selected_link: selected_link, multi_selected_links: multi_selected_links, menu_configuration_links: Object.values(menu_configuration_links), style_editable: style_editable, set_displayed_value: set_displayed_value, tags_selected: tags_selected, set_tags_selected: set_tags_selected })))))),
        react_1.default.createElement(Accordion_1.default.Item, { key: '8', id: "dataTags", eventKey: "dimension", style: { 'display': (data.accordeonToShow.includes('ED')) ? 'block' : 'none' }, onClick: evt => {
                if (evt.target.className === 'accordion-button' && nav_item_active === 'dimension') {
                    set_nav_item_active('');
                }
                else {
                    set_nav_item_active('dimension');
                }
            } },
            react_1.default.createElement(Accordion_1.default.Header, null, t('Menu.ED')),
            react_1.default.createElement(Accordion_1.default.Body, null, menu_configuration_data_tags)),
        react_1.default.createElement(Accordion_1.default.Item, { key: '10', id: "Legend", style: { 'display': (data.accordeonToShow.includes('Leg')) ? 'block' : 'none' }, eventKey: "legend", onClick: evt => {
                if (evt.target.className === 'accordion-button' && nav_item_active === 'legend') {
                    set_nav_item_active('');
                }
                else {
                    set_nav_item_active('legend');
                }
            } },
            react_1.default.createElement(Accordion_1.default.Header, null, t('Menu.Leg')),
            react_1.default.createElement(Accordion_1.default.Body, null, menu_configuration_legends.map((c, i) => {
                return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
            }))),
        react_1.default.createElement(react_1.default.Fragment, null, menu_configuration_free_labels),
    ];
};
exports.OpenSankeyConfigurationsMenus = OpenSankeyConfigurationsMenus;
/**
 * Variable that define the Menu element, it's variable and function
 *
 * @type {{ data: any; set_data: any;right_menu: any; settings_edition: any; settings_edition_node_tags: any; settings_edition_link_tags: any; settings_edition_data_tags: any; ... 39 more ...; launch: any; }}
 */
const ConfigurationMenuPropTypes = {
    accordion_ref: prop_types_1.default.shape({ current: prop_types_1.default.instanceOf(HTMLDivElement) }).isRequired,
    nav_item_active: prop_types_1.default.string.isRequired,
    configuration_menus: prop_types_1.default.arrayOf(prop_types_1.default.element.isRequired).isRequired
};
const SankeyConfigurationMenu = ({ nav_item_active, accordion_ref, configuration_menus }) => {
    return (react_1.default.createElement(Accordion_1.default, { ref: accordion_ref, activeKey: nav_item_active }, configuration_menus.map((c, i) => {
        return react_1.default.createElement(react_1.default.Fragment, { key: i }, c);
    })));
};
exports.SankeyConfigurationMenu = SankeyConfigurationMenu;
